import React, { useEffect } from "react";
import "./CountingDepartmentContainer.less";
import { Tabs, Col, Row } from "antd";
import { useDispatch, useSelector } from "react-redux";
import InvoiceCreateByPeriod from "../../components/InvoiceCreateByPeriod/InvoiceCreateByPeriod";
import BillFactur from "../../components/BillFactur/BillFactur";
import { fetchGlsStatuses, fetchGlsTypes, fetchSequence } from "../../store/slices/rtkDictionaries";
import { hasAccess } from "../../components/RolesModule/hasAccess";
import { BILLING_ACCOUNTING_SYSTEM_EXPORT, BILLING_ACCOUNTING_SYSTEM_EXTNUM, BILLING_ACCOUNTING_SYSTEM_PROCEDURES, BILLING_ACCOUNTING_SYSTEM_TASKS, MENU_BILLING_ACCOUNTINGSYSTEM, MENU_BILLING_ACCOUNTINGSYSTEM_WRITE } from "../../lib/const/permissions";
import DataExporter from "../../components/DataExporter/DataExporter";
import TaskCreator from "../../components/TaskCreator/TaskCreator";
import ErrorPage from "../../components/ErrorPage/ErrorPage";

const CountingDepartmentContainer = () => {
  const { TabPane } = Tabs;
  const dispatch = useDispatch();
  const { sequence, sequenceLoading } = useSelector((state) => state.rtkDictionaries);

  useEffect(() => {
    dispatch(fetchSequence());
    dispatch(fetchGlsTypes())
    dispatch(fetchGlsStatuses())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const tabs = [
    {
      key: "1",
      tabName: "Экспорт",
      content: <InvoiceCreateByPeriod />,
      isAccess: hasAccess(BILLING_ACCOUNTING_SYSTEM_EXPORT),
    },
    {
      key: "2",
      tabName: "Создание заданий",
      content: <TaskCreator />,
      isAccess: hasAccess(MENU_BILLING_ACCOUNTINGSYSTEM_WRITE) && hasAccess(BILLING_ACCOUNTING_SYSTEM_TASKS),
    },
    {
      key: "3",
      tabName: "Процедуры выгрузки",
      content: <DataExporter />,
      isAccess: hasAccess(BILLING_ACCOUNTING_SYSTEM_PROCEDURES),
    },
    {
      key: "4",
      tabName: "Нумерация счетов-фактур",
      content: <BillFactur sequence={sequence} sequenceLoading={sequenceLoading} />,
      isAccess: hasAccess(BILLING_ACCOUNTING_SYSTEM_EXTNUM),
    },
  ];

  const filteredTabs = tabs.filter((tab) => tab.isAccess);

  return (
    <div className="container_height">
      <div className="inner-row">
        <Row justify="space-between" align="middle">
          <Col>
            <h1>Выгрузка в финансовые системы</h1>
          </Col>
        </Row>
        {filteredTabs.length > 0 ?
          <Tabs className="bill-history-modal-tabs" destroyInactiveTabPane >
            {filteredTabs.map((tab) => (
              <TabPane tab={tab.tabName} key={tab.key}>
                {tab.content}
              </TabPane>
            ))}
          </Tabs> : <ErrorPage />}
      </div>
    </div>
  );
};

export default CountingDepartmentContainer;
